import { render } from "./TrailerModal.vue?vue&type=template&id=384e6a0a&ts=true"
import script from "./TrailerModal.vue?vue&type=script&lang=ts"
export * from "./TrailerModal.vue?vue&type=script&lang=ts"

import "./TrailerModal.vue?vue&type=style&index=0&id=384e6a0a&lang=scss"

import exportComponent from "/builds/filmin/press-center/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__